import { randomBytes } from 'crypto';
function getCookieValue(cookieName: string) {
  const name = `${cookieName}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}
export async function finishTrainingApi(postBody: any): Promise<any> {
  try {
    const response = await fetch(`/api/finishTraining`, {
      method: 'POST',
      body: JSON.stringify({
        ...postBody,
        token: getCookieValue('oauth_token'),
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      console.log('Training finished successfully');
    } else {
      console.error('Failed to finish training');
    }
  } catch (error) {
    console.error('Error occurred while finishing training:', error);
  }
}
export const generateVerificationCode = () => {
  const buffer = randomBytes(8);
  return buffer.toString('hex').toUpperCase().slice(0, 16);
};
/**
 * 格式化日期（默认当前日期）
 * @param options - 格式化选项
 * @param options.date - 可选的日期对象，默认为当前日期
 * @param options.separator - 分隔符，默认为斜杠 `/`
 * @param options.padZero - 是否补零，默认为 false
 * @returns 格式化后的日期字符串
 */
export const formatDate = ({
  date = new Date(),
  separator = '/',
  padZero = false,
}: {
  date?: Date;
  separator?: string;
  padZero?: boolean;
} = {}): string => {
  const year = date.getFullYear();
  const month = padZero
    ? String(date.getMonth() + 1).padStart(2, '0')
    : date.getMonth() + 1;
  const day = padZero
    ? String(date.getDate()).padStart(2, '0')
    : date.getDate();

  return [year, month, day].join(separator);
};

export const pathToName = (path: string) =>
  ({
    cybersecurity2026: 'general staff training 2026',
    education: 'education training',
    'general-staff': 'general staff training',
    cybersecurity2024: 'staff training 2024',
    student: 'student pre-career training',
    'student-training': 'student pre-career training',
    civil: 'civil servant training',
    sme: 'sme sector training',
    'senior-manager': 'senior management training',
    finance: 'finance and accounting training',
    hr: 'human resource management training',
    market: 'marketing training',
    customer: 'customer service training',
    it: 'it training',
    'E-commerce': 'e-commerce industry training',
    ngo: 'ngo training',
    startup: 'tech start-ups training',
    fsi: 'financial service industry training',
  }[path] || 'training');
export async function sendEmail(formData: any): Promise<any> {
  const headers = new Headers();
  try {
    const response = await fetch(`/api/email`, {
      method: 'POST',
      body: formData,
      headers,
    });
    if (response.ok) {
      console.log('Training finished successfully');
    } else {
      console.error('Failed to finish training');
    }
  } catch (error) {
    console.error('Error occurred while finishing training:', error);
  }
}

export async function finishTrainingMoreDataApi(postBody: {
  name: string;
  type: string;
  email: string;
  certificateNumber: string;
  date: string;
  time: string;
}): Promise<any> {
  try {
    const response = await fetch(`/api/finishTrainingMoreData`, {
      method: 'POST',
      body: JSON.stringify(postBody),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response.ok) {
      console.log('Finish training more data successfully');
    } else {
      console.error('Failed to finish training more data');
    }
  } catch (error) {
    console.error('Error occurred while finishing training more data:', error);
  }
}

export const formatTime = (date = new Date()): string => {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};
